import { useState } from 'react';
import { tableColumnConfigs } from './TableHeader.consts';
import { TableHeaderProps } from './TableHeader.types';
import { SortAscIcon, SortDescIcon } from '../../../../../icons/SvgIcons';

export function TableHeader({
  className = '',
  type,
  sortBy,
  sortOrder,
  onSort,
  invitedUserOnly = false
}: TableHeaderProps) {
  const columns = tableColumnConfigs[type];
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);

  const handleSort = (sortKey: string) => {
    if (onSort) {
      onSort(sortKey);
    }
  };

  return (
    <thead className={`w-full ${className}`}>
      <tr className="w-full flex flex-row">
        {columns.map((column, index) => {
          const isActive = sortBy === column.sortKey && sortOrder;
          const isHovered = hoveredColumn === column.sortKey;
          const showIcon = column.sortable && (isActive || isHovered);

          let label = column.label;
          if (column.label === 'SYSTEM NAME') {
            label = 'SYSTEM NAME';
          } else if (invitedUserOnly && column.label === 'Registered Users') {
            label = 'INVITED USERS';
          }

          return (
            <th
              key={index}
              className={`${
                column.width
              } flex items-center py-3 px-6 gap-1 bg-gray-40 text-xs font-medium tracking-wider text-gray-550 hover:text-gray-850 uppercase ${
                column.className || ''
              } ${
                column.sortable
                  ? 'cursor-pointer transition-colors hover:bg-gray-100'
                  : ''
              }`}
              onMouseEnter={() =>
                column.sortable && setHoveredColumn(column.sortKey || null)
              }
              onMouseLeave={() => setHoveredColumn(null)}
              onClick={() =>
                column.sortable && column.sortKey && handleSort(column.sortKey)
              }
            >
              {label}
              <span>
                {showIcon &&
                  (sortOrder === 'desc' ? SortDescIcon() : SortAscIcon())}
              </span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
